module.exports = __webpack_public_path__ + "static/img/gaoreliang.2b4b254a.svg";